(function () {
  'use strict';

  function formatDate(date) {
    var weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
    var months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + months[date.getMonth()];
  }

  function renderShippingDate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var date = new Date();
    date.setDate(date.getDate() + 2);
    var label = formatDate(date);

    scope.querySelectorAll('[data-hh-gf-date]').forEach(function (node) {
      node.textContent = label;
    });
  }

  function initReveal(root) {
    var page = (root && root.matches && root.matches('[data-hh-gf-page]'))
      ? root
      : (root && root.querySelector ? root.querySelector('[data-hh-gf-page]') : null);

    if (!page || page.dataset.hhGfReady === 'true') return;
    page.dataset.hhGfReady = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      page.querySelectorAll('.hh-gf-reveal').forEach(function (element) {
        element.classList.add('hh-gf-visible');
      });
      return;
    }

    page.classList.add('hh-gf-enhanced');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hh-gf-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    page.querySelectorAll('.hh-gf-reveal').forEach(function (element) {
      observer.observe(element);
    });
  }

  function init(root) {
    renderShippingDate(root || document);
    initReveal(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });

  var observer = new MutationObserver(function () {
    var pendingDate = document.querySelector('[data-hh-gf-date]:empty');
    if (pendingDate) renderShippingDate(document);
  });

  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
